import { IProduct } from './IProduct';
import { IMasterSync } from './IMasterSync';
import { Pool } from '../../../apis/pool.api';

export type RestaurationConfiguration = {
  sourceIndex: number;
  destinationIndex: number;
};

export abstract class IMaster extends IProduct {
  sharedKey?: string;

  isMaster?: boolean = true;

  deviceTable: any = null;

  abstract getManager(): IMasterSync;

  abstract resetAddProduct(pool: Pool, product: IProduct): any;

  abstract saveAll(): any;

  abstract addProduct(pool: Pool, product: IProduct): any;

  abstract hasProduct(pool: Pool, product: IProduct): number;

  abstract hasConnect(pool: Pool): any;

  abstract removeProduct(pool: Pool, product: IProduct): any;

  abstract restaurationConfiguration(): RestaurationConfiguration[];
}
